<template>
    <MultiselectComponent v-bind="multiselectSettings" v-model:selected="flags">
        <template #option="props">
            <template v-if="props.option.$isLabel">
                <strong>{{ props.option.$groupLabel }}</strong>
            </template>
            <template v-else>
                <div class="d-flex justify-content-between">
                    <span>{{ props.option.name }}</span>
                    <span class="text-muted text-end ml-4">{{ props.option.count }}</span>
                </div>
            </template>
        </template>
        <template #noOptions="props" v-if="flags">
            {{ $t("multiselect.noOptionsWithResult") }}
        </template>
        <template #noOptions="props" v-else>
            {{ $t("multiselect.noOptions") }}
        </template>
        <template #noResults="props">
            {{ $t("multiselect.noResults") }}
        </template>
    </MultiselectComponent>
</template>


<script>
import MultiselectComponent from "@/components/MultiselectComponent.vue";

export default {
    name: "multiselect-filter",
    props: {
        type: { type: String, required: true },
        version: { required: true },
        hash: { required: true }
    },
    components: { MultiselectComponent },
    data: function () {
        return {
            flags: [],
            changed: false,
            loading: false,
            options: [],
            returned_flags: [],
            retry: false
        };
    },
    created: function () {
        this.returned_flags = this.analysis.flags;
        var flags = undefined;

        // add supplier flags from main page
        if (this.type == "supplier" && this.$store.getters.supplierTableFilter.flag) {
            flags = this.$store.getters.supplierTableFilter.flag[0];
            if (flags !== undefined) {
                this.flags.push(flags);
            }
        }

        // add contract flags from main page
        if (this.type == "contract" && this.$store.getters.contractTableFilter.flag) {
            flags = this.$store.getters.contractTableFilter.flag[0];
            if (flags !== undefined) {
                this.flags.push(flags);
            }
        }

        // add tender flags from main page
        if (this.type == "tender" && this.$store.getters.tenderTableFilter.flag) {
            flags = this.$store.getters.tenderTableFilter.flag[0]
            if (flags !== undefined) {
                this.flags.push(flags);
            }
        }
    },
    watch: {
        flags: function (new_flags) {
            if (new_flags !== null && new_flags.length !== 0) {
                this.changed = true;
                this.loading = true;
                this.options = [];
                this.changeFlags();
            }
            else {
                this.changed = false;
                this.loading = false;
                this.returned_flags = this.analysis.flags;
            }
            this.$emit("flags", new_flags);
        },
        returned_flags: function (flags) {
            if (flags === undefined) {
                this.options = [];
                // if something went wrong with loading try it one more time
                if (!this.retry) {
                    this.changeFlags();
                    this.retry = true;
                }
                return
            }
            // set retry to false if everything is fine
            this.retry = false;
            var options = [];
            flags.forEach(g => {
                var list = []
                g.flags.forEach(n => {
                    if (this.type == "supplier") {
                        // add flag to list if its default list or if count is not zero
                        if (!this.changed || n.count_suppliers > 0) {
                            list.push({ name: n.name, count: n.count_suppliers })
                        }
                    }
                    else if (this.type == "tender") {
                        // add flag to list if its default list or if count is not zero
                        if (!this.changed || n.count_tenders > 0 || n.count_suppliers_tenders > 0) {
                            var count = n.count_tenders || n.count_suppliers_tenders;
                            list.push({
                                name: n.name, count: count
                            })
                        }
                    }
                    else if (this.type == "contract") {
                        // add flag to list if its default list or if count is not zero
                        if (!this.changed || n.count_contracts > 0) {
                            list.push({ name: n.name, count: n.count_contracts })
                        }
                    }
                })
                // add category if its default list or if list is not empty
                if (!this.changed || list.length > 0) {
                    options.push({ group: g.name, list: list })
                }
            });

            this.options = options;
        }
    },
    computed: {
        analysis: function () {
            return this.$store.state.analysis;
        },
        multiselectSettings: function () {
            var placeholder = this.$t("overview.suppliers.table.filter.flags.all");
            if (this.flags.length > 0) {
                placeholder = this.$t("overview.suppliers.table.filter.flags.write")
            }
            return {
                options: this.options,
                multiple: true,
                closeOnSelect: false,
                groupValues: "list",
                groupLabel: "group",
                groupSelect: true,
                trackBy: "name",
                customLabel: ({ name }) => `${name}`,
                placeholder: placeholder,
                selectLabel: this.$t("multiselect.selectLabel"),
                selectedLabel: this.$t("multiselect.selectedLabel"),
                deselectLabel: this.$t("multiselect.deselectLabel"),
                selectGroupLabel: this.$t("multiselect.selectGroupLabel"),
                deselectGroupLabel: this.$t("multiselect.deselectGroupLabel"),
                showLabels: false,
                loading: this.loading
            };
        }
    },
    methods: {
        changeFlags: function () {
            var params = {};
            params[`${this.version}_hash`] = this.hash;
            params['flags'] = JSON.stringify(this.flags)
            params['type'] = this.type;
            this.$store.getters.api
                .get("get_flags/", { params: params })
                .then((response) => {
                    this.returned_flags = response.data.flags;
                })
                .catch((e) => {
                    console.dir(e);
                    this.returned_flags = [];
                })
                .finally(() => (this.loading = false));
        }
    }
};
</script>